// @flow

type Data = {|
  compositePropertyType: string,
  offerType: string,
  slug?: ?string,
|};

export const makeListingHref = (
  listing: Data,
): {|
  pathname: string,
  query: {| compositePropertyType_eq: string, offerType: string |},
|} => {
  const href = {
    pathname: '/listing',
    query: {
      compositePropertyType_eq: JSON.stringify(listing.compositePropertyType),
      offerType: JSON.stringify(listing.offerType),
    },
  };

  // if (listing.slug != null) {
  href.query = {
    ...href.query,
    listingSlug: JSON.stringify(listing.slug),
  };

  return href;
};
